export default {
  label: {
    yAxisTitle: 'Publicações',
  },
};
